import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserNotificationsDialogModel } from './user-notifications-dialog.model';
import { PresenterType } from '@shared/components/presenter/presenter-type';


@PresenterType({
  model: UserNotificationsDialogModel,
  key: 'title'
})

@Component({
  selector: 'user-notification-dialog-header',
  standalone: false,
  templateUrl: './user-notification-dialog-header.component.html',
  styleUrl: './user-notification-dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNotificationDialogHeaderComponent {

}
